import { render, staticRenderFns } from "./GeneralManager.vue?vue&type=template&id=72b10124&scoped=true"
import script from "./GeneralManager.vue?vue&type=script&lang=js"
export * from "./GeneralManager.vue?vue&type=script&lang=js"
import style0 from "./GeneralManager.vue?vue&type=style&index=0&id=72b10124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b10124",
  null
  
)

export default component.exports